<template>
	<v-dialog
		:value="value"
		max-width="520"
		persistent
		@input="$emit('input', $event)"
	>
		<v-card>
			<v-card-title class="text-h6">
				Uso de Inteligência Artificial
			</v-card-title>

			<v-card-text class="pt-2">
				{{ consentText }}
			</v-card-text>

			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>

				<v-btn
					color="#F15A24"
					text
					@click="$emit('cancel')"
				>
					Cancelar
				</v-btn>

				<v-btn
					color="#F15A24"
					dark
					@click="$emit('accept')"
				>
					Aceitar e Continuar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { AI_CONSENT_TEXT } from '../composables/useAiConsent';

export default {
	name: 'AiConsentDialog',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		consentText: {
			type: String,
			default: AI_CONSENT_TEXT,
		},
	},
};
</script>
